<template>
  <component
    :id="id"
    :is="messageComponent"
    :message="message"
    :has-next="hasNext"
    :same-minute="isWithinSameMinute"
  >
    <component
      v-if="isBubble"
      :is="messageTypeComponent"
      :message="message"
      :id="id"
    />
  </component>
</template>

<script>
export default {
  components: {
    MessageAudio: () => import('@/components/chat/message/MessageAudio.vue'),
    MessageBubble: () => import('@/components/chat/message/MessageBubble.vue'),
    MessageDocument: () => import('@/components/chat/message/MessageDocument.vue'),
    MessageImage: () => import('@/components/chat/message/MessageImage.vue'),
    MessageLocation: () => import('@/components/chat/message/MessageLocation.vue'),
    MessageNotification: () => import('@/components/chat/message/MessageNotification.vue'),
    MessageText: () => import('@/components/chat/message/MessageText.vue'),
    MessageVideo: () => import('@/components/chat/message/MessageVideo.vue'),
    MessageSticker: () => import('@/components/chat/message/MessageSticker.vue'),
    MessageTextTemplate: () => import('@/components/chat/message/MessageTextTemplate.vue'),
    MessageDeleted: () => import('@/components/chat/message/MessageDeleted.vue'),
  },
  props: {
    message: {
      required: true,
      type: Object,
    },
    hasNext: {
      default: false,
    },
    isWithinSameMinute: {
      default: false,
    },
    id: {
      type: String,
    },
  },
  computed: {
    isBubble() {
      return ['Client', 'User', 'UserSystem'].includes(this.message.typeUser);
    },
    messageComponent() {
      return this.isBubble ? 'message-bubble' : 'message-notification';
    },
    messageTypeComponent() {
      if (this.message.errorCode === '9999') {
        return 'message-deleted';
      }

      switch (this.message.type) {
        case 'text':
          return 'message-text';
        case 'image':
          return 'message-image';
        case 'video':
          return 'message-video';
        case 'audio':
        case 'voice':
          return 'message-audio';
        case 'document':
          return 'message-document';
        case 'location':
          return 'message-location';
        case 'tText':
          return 'message-text-template';
        case 'sticker':
          return 'message-sticker';
        default:
          return '';
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "~styles/components/chat/_index.scss";
</style>
